<template>
  <tr>
    <td class="text-right">
      <input
          v-if="isPrivileged"
          type="checkbox"
          class="form-check-input shadow-none cursor-pointer border-success activity-checkbox"
          :class="{'checkbox-success-checked': item.completion_status === 'completed'}"
          :checked="item.completion_status === 'completed'"
          @click.prevent="onOpenCompletionModal"
        >
    </td>
    <td>
      <div class="d-flex align-items-center">
        <span class="text-primary cursor-pointer fw-bold hover-underline" @click="onOpenActivityDetailModal(item)">
          {{ item.name }}
        </span>
      </div>

      <CompletionModal 
        v-model:show="showModal" 
        :item="item" 
        @success="handleCompletionSuccess" 
      />
    </td>
    <td>{{ item.unit_name }}</td>
    <td class="text-right">{{ commaFormat(item.budget_quantity) }}</td>
    <td class="text-primary cursor-pointer hover-underline fw-bold text-right" @click="onOpenActivityLogModal">
      {{ commaFormat(item.already_achieved) }}
    </td>
    <td class="text-right">{{ commaFormat(item.budget_quantity - item.already_achieved) }}</td>
    <td class="text-right">{{ commaFormat(item.current_target) }}</td>
    <td>
      <input :disabled="isAchievementDisabled" class="form-control shadow-sm text-right" v-model="item.hours" type="number" step="0.01">
    </td>
    <td>
      <input :readonly="!item.hours" class="form-control shadow-sm" placeholder="Task Note" v-model="item.full_description"
                type="text">
    </td>
    <td class="text-center">
      <div v-if="item.completion_status !== 'completed'" @click="onOpenQuickScheduler">
        <i class="fas fa-calendar-alt text-primary cursor-pointer fs-4"></i>
      </div>

      <QuickTaskSchedulerModal 
          v-model:show="showQuickScheduler" 
          :item="item" 
          @success="handleQuickSchedulerSuccess"
      />

      <ActivityLogDetailModal 
        v-model:show="showActivityLogModal" 
        :item="item" 
      />
    </td>
  </tr>
</template>

<script setup>
import {computed, defineProps, inject, onMounted, ref, watch} from 'vue';
import handleCrm from "@/services/modules/crm/crm";
import CompletionModal from "./CompletionModal.vue";
import QuickTaskSchedulerModal from "./QuickTaskSchedulerModal.vue";
import ActivityLogDetailModal from "./ActivityLogDetailModal.vue";
import figureFormatter from "@/services/utils/figureFormatter";

const { commaFormat } = figureFormatter();

const onOpenActivityDetailModal = inject('onOpenActivityDetailModal');
const isPrivileged = inject('isPrivileged', ref(false));
const areaRef = ref()
const {fetchAreaList} = handleCrm();

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
});

const showModal = ref(false);
const showQuickScheduler = ref(false);
const showActivityLogModal = ref(false);

const hasTarget = computed(() => Number(props.item.budget_quantity) > 0);

const isAchievementDisabled = computed(() => {
  if (props.item.completion_status === 'completed') return true;
  return ! hasTarget.value;
});

const onOpenCompletionModal = (e) => {
  showModal.value = true;
};

const onOpenActivityLogModal = () => {
  showActivityLogModal.value = true;
};

const onOpenQuickScheduler = () => {
  showQuickScheduler.value = true;
};

const handleCompletionSuccess = (result) => {
  props.item.completion_status = result.status;
  props.item.completion_note = result.note;
};

const handleQuickSchedulerSuccess = (completionNote) => {
  if (completionNote !== null) {
    props.item.completion_status = 'completed';
    props.item.completion_note = completionNote;
  }
};

watch(
    () => props.item,
    (newItem) => {
      areaRef.value = {
        id: newItem.area_id,
        name: newItem.area_name,
        amount: newItem.conveyance,
      };
    }
);

onMounted(()=>{
  areaRef.value = {
    id: props.item.area_id,
    name: props.item.area_name,
    amount: props.item.conveyance,
  };
})

</script>

<style scoped>
td {
  padding: 5px 15px;
}
.hover-underline:hover {
  text-decoration: underline;
}
.cursor-pointer {
  cursor: pointer;
}
.checkbox-success-checked {
  background-color: #28c76f !important; /* Bootstrap success color */
  border-color: #28c76f !important;
}
.activity-checkbox {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0;
}
</style>
